module.exports = __webpack_public_path__ + "6ab3877d5b6d0826ff5b4e20455d8871.svg";